<template>
  <div class="myRequest">
    <van-tabs v-model="active">
      <van-tab :title="`全部${all?`（${all}）`:''}`"></van-tab>
      <van-tab :title="`已审批${approveDone?`（${approveDone}）`:''}`"></van-tab>
      <van-tab :title="`不同意${no?`（${no}）`:''}`"></van-tab>
    </van-tabs>
    <!-- <div class="searchBox">
      <div class="search">
        <input type="text" v-model.trim="searchForm.workflowName" placeholder="请输入工作流名称" />
        <span @click="handleSearch" >
          <svg-icon icon-class="search" style="cursor:pointer;"/>
        </span>
      </div>
    </div> -->
    <div class="wrap">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
        <div class="item" v-for="(item, index) in data" :key="index">
          <div class="top">
            <div @click="goTo(item, 'detail')">
              <div class="title">{{ item.workflowName }}</div>
              <div class="text">{{ item.createTime }}</div>
            </div>
            <!-- <span
              v-if="item.statusName == '审批中'"
              :style="{ color: 'rgb(86, 138, 205)' }"
              >{{ item.statusName }}</span
            > -->
            <span
              v-if="item.status == 2"
              :style="{ color: 'rgb(240, 58, 58)' }"
              >{{ item.statusName }}</span
            >
            <span v-else>{{ item.statusName }}</span>
          </div>
          <div class="van-hairline--bottom fg"></div>
          <div class="btnBox noCopy">
            <van-button v-show="item.status == 0 || item.status == 2" @click="goTo(item, 'edit')"
              >修改提交</van-button
            >
            <!-- <van-button @click="goTo(item, 'edit')"
              >修改提交</van-button
            > -->
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getData(this.searchForm);
  },
  data() {
    return {
      loading: false,
      finished: false,
      active: 0,
      data: [],
      total: 0,
      all:0,
      approveDone: 0,
      no: 0,
      searchForm: {
        pageNum: 1,
        pageRows: 10,
        type:1,
        workflowName:""
      },
    };
  },
  watch: {
    active(newval) {
      this.finished = false;
      if (newval == 0) {
        this.searchForm.type = 1
        this.searchForm.pageRows = 10
        this.getData(this.searchForm);
      }
      if (newval == 1) {
        this.searchForm.type = 2
        this.searchForm.pageRows = 10
        this.getData(this.searchForm);
      }
      if (newval == 2) {
        this.searchForm.type = 3
        this.searchForm.pageRows = 10
        this.getData(this.searchForm);
      }
    },
  },
  methods: {
    handleSearch(){
      this.searchForm.pageRows = 10
      this.getData(this.searchForm)
    },
    onLoad() {
      this.searchForm.pageRows += 10
      this.getData(this.searchForm);
    },
    goTo(item, type) {
      let path = "";
      let workflow = "";
      if (item.workflow==0) {
        if (type == "detail") path = "/sqDetail";
        if (type == "edit") path = "/travelSq";
        workflow = "0";
      }
      if (item.workflow==1) {
        if (type == "detail") path = "/ccDetail";
        if (type == "edit") path = "/travelBx";
        workflow = "1";
      }
      if (item.workflow==2) {
        if (type == "detail") path = "/cityDetail";
        if (type == "edit") path = "/cityBx";
        workflow = "2";
      }
      if (item.workflow==3) {
        if (type == "detail") path = "/lxDetail";
        if (type == "edit") path = "/pettyExpenseBx";
        workflow = "3";
      }
      if (
        item.workflow==4
      ) {
        if (type == "detail") path = "/cbDetail";
        if (type == "edit") path = "/excessiveApplication";
        workflow = "4";
      }
      if (item.workflow==5) {
        if (type == "detail") path = "/bx5detail";
        if (type == "edit") path = "/bx5";
        workflow = "5";
      }
      if (item.workflow==6) {
        if (type == "detail") path = "/bx6detail";
        if (type == "edit") path = "/bx6";
        workflow = "6";
      }
      if (item.workflow==7) {
        if (type == "detail") path = "/bx7detail";
        if (type == "edit") path = "/bx7";
        workflow = "7";
      }
      if (item.workflow==8) {
        if (type == "detail") path = "/bx8detail";
        if (type == "edit") path = "/bx8";
        workflow = "8";
      }
      if (item.workflow==9) {
        if (type == "detail") path = "/bx9detail";
        if (type == "edit") path = "/bx9";
        workflow = "9";
      }
      if (item.workflow==10) {
        if (type == "detail") path = "/bx10detail";
        if (type == "edit") path = "/bx10";
        workflow = "10";
      }
      if (item.workflow==11) {
        if (type == "detail") path = "/bx11detail";
        if (type == "edit") path = "/bx11";
        workflow = "11";
      }
      if (item.workflow==12) {
        if (type == "detail") path = "/bx12detail";
        if (type == "edit") path = "/bx12";
        workflow = "12";
      }
      if (item.workflow==13) {
        if (type == "detail") path = "/bx13detail";
        if (type == "edit") path = "/bx13";
        workflow = "13";
      }
      this.$router.push({
        path: path,
        query: {
          id: item.id,
          type,
          statusName: item.statusName,
        },
        name:path.split("/")[1],
        params:{
          fristEnter:true
        }
      });
    },
    getData(searchForm = {}) {
      this.$api
        .post("/payment/center/reimburse/getAppList", {
          reqData: {
            ...searchForm,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.data = res.repData.list;
            this.approveDone = res.repData.list.filter(
              (item) => item.statusName == "已审批"
            ).length;
            this.no = res.repData.list.filter(
              (item) => item.statusName == "不同意"
            ).length;
            this.total = res.repData.total;
            if(this.active == 0){
              this.all = res.repData.total
              this.approveDone = 0
              this.no = 0
            }
            if(this.active == 1){
              this.all = 0
              this.approveDone = res.repData.total
              this.no = 0
            }
            if(this.active == 2){
              this.all = 0
              this.approveDone = 0
              this.no = res.repData.total
            }
            this.loading = false;
            if (this.total == this.data.length) {
              this.finished = true;
            }
          }else{
            this.finished = true
          }
        }).catch(()=>{
          this.finished = true
        })
    },
  },
};
</script>

<style lang="scss">
.myRequest {
  height: 100%;
  display: flex;
  flex-direction: column;
  .searchBox {
    padding: 10px 18px;
    // background: #fff;
    .search {
      display: flex;
      align-items: center;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 10px;
      input {
        flex: 1;
        outline: none;
        border: none;
        background:rgba($color: #000000, $alpha: .0);
      }
    }
  }
  .van-tabs__line {
    width: calc(100% / 3);
  }
  .wrap {
    flex: 1;
    overflow-y: auto;
    margin-top: 10px;
    padding: 0 16px;
  }
  .item {
    width: 100%;
    border-radius: 4px;
    box-shadow: 1px 2px 2px 0 #e2dada;
    background: #fff;
    padding: 10px 20px;
    margin-bottom: 10px;
    color: rgb(153, 153, 153);
    line-height: 22px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        width: 90px;
        text-align: center;
        font-size: 14px;
      }
    }
    .title {
      color: rgb(75, 76, 75);
      margin-top: 4px;
    }
    .fg {
      margin-top: 4px;
    }
    .btnBox {
      display: flex;
      justify-content: flex-end;
      padding-top: 10px;
      button {
        width: 90px;
        height: 24px;
        border-radius: 30px;
        color: rgb(75, 76, 75);
        font-size: 12px;
      }
    }
  }
}
</style>